import BaseModel from '../core/BaseModel'
import AreaModel from "@/models/AreaModel";
//import gql from 'graphql-tag'
export default class ReportGeneralEmployeeInventoryModel extends BaseModel {

    constructor() {
        super({ 
                name: "report_general_employee_inventory",
                tableName: 'users', 
                label: "Báo cáo tổng hợp VB tồn nhân viên", 
                display_key: 'fullname', 
                default_order: { key: 'created_at', direction: 'asc' } }, 
            {
            stt: {
                name: "stt",
                label: "STT",
                type: "String",
                width: 4,
                class: "center",
                computed: (data, index) => {
                    data.stt = index + 1;
                },
            },
            id: { 
                name: 'id', 
                type: "Uuid", 
                label: 'ID', 
                primaryKey: true, 
                display: false
            },
            code: {
                name: 'code', 
                type: "String",
                label: 'Mã nhân viên',
                width: 8,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                // display: false
            },
            fullname: {
                name: 'fullname', 
                type: "String",
                label: 'Tên nhân viên',
                width: 10,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                // display: false,
            },
                area_id: {
                name: "area_id",
                label: "Mã khu vực",
                width: 9,
                class: "center",
                type: "Selection",
                models: new AreaModel(),
                filter: { type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals' },
            },
            areas: {
                refs: 'areas {id name:code}',
                display: false
            },
            vb_chua_chuyen_trong_han_key: {
                name: 'vb_chua_chuyen_trong_han_key', 
                type: "Computed",
                label: 'Tổng VB chưa chuyển hình thức trong hạn',
                width: 8,
                class: "center",
                // filter: { type: 'input', match: 'contains'},
                // display: false
                computed: (data) => {
                    data.vb_chua_chuyen_trong_han_key = data?.vb_chua_chuyen_trong_han ?? 0 
                },
            },
            // doc_waiting_no_scan_ref: {
            //     refs: 'view_tdv_total_doc_waiting_no_scan_aggregate {aggregate {count}}',
            //     display: false
            // },
            vb_chua_chuyen_tre_han_key: {
                name: 'vb_chua_chuyen_tre_han_key', 
                type: "Computed",
                label: 'Tổng số VB chưa chuyển hình thức trễ hạn',
                width: 10,
                class: "center",
                // filter: { type: 'input', match: 'contains'},
                // display: false
                computed: (data) => {
                    data.vb_chua_chuyen_tre_han_key = data?.vb_chua_chuyen_tre_han ?? 0 
                },
            },
            // doc_normal_tt_gn_nt3_ref: {
            //     refs: 'view_tdv_total_doc_normal_tt_gn_nt3_aggregate {aggregate {count}}',
            //     display: false
            // },
            td_tructiep_trong_han_key: {
                name: 'td_tructiep_trong_han_key', 
                type: "Computed",
                label: 'Tổng số VB TĐ trực tiếp trong hạn',
                width: 12,
                class: "center",
                // filter: { type: 'input', match: 'contains'},
                // display: false
                computed: (data) => {
                    data.td_tructiep_trong_han_key = data?.td_tructiep_trong_han ?? 0 
                },
            },
            td_tructiep_tre_han_key: {
                name: 'td_tructiep_tre_han_key', 
                type: "Computed",
                label: 'Tổng số VB TĐ trực tiếp trễ hạn',
                width: 12,
                class: "center",
                // filter: { type: 'input', match: 'contains'},
                // display: false
                computed: (data) => {
                    data.td_tructiep_tre_han_key = data?.td_tructiep_tre_han ?? 0 
                },
            },
            // doc_doc_normal_kt_ref: {
            //     refs: 'view_tdv_total_doc_normal_kt_aggregate {aggregate {count}}',
            //     display: false
            // },
            td_tructiep_ub_trong_han_key: {
                name: 'td_tructiep_ub_trong_han_key', 
                type: "Computed",
                label: 'Tổng số VB TĐ trực tiếp có XN UB trong hạn',
                width: 10,
                class: "center",
                // filter: { type: 'input', match: 'contains'},
                // display: false
                computed: (data) => {
                    data.td_tructiep_ub_trong_han_key = data?.td_tructiep_ub_trong_han ?? 0 
                },
            },
            // doc_doc_normal_ny_ref: {
            //     refs: 'view_tdv_total_doc_normal_ny_aggregate {aggregate {count}}',
            //     display: false
            // },
            td_tructiep_ub_tre_han_key: {
                name: 'td_tructiep_ub_tre_han_key', 
                type: "Computed",
                label: 'Tổng số VB TĐ trực tiếp có XN UB trễ hạn',
                width: 10,
                class: "center",
                // filter: { type: 'input', match: 'contains'},
                // display: false
                computed: (data) => {
                    data.td_tructiep_ub_tre_han_key = data?.td_tructiep_ub_tre_han ?? 0 
                },
            },
            // doc_confirmed_ref: {
            //     refs: 'view_tdv_total_doc_confirmed_aggregate {aggregate {count}}',
            //     display: false
            // },
            td_giaonhan_trong_han_key: {
                name: 'td_giaonhan_trong_han_key',
                type: "Computed",
                label: 'Tổng VB TĐ giao nhận trong hạn',
                width: 10,
                class: "center",
                computed: (data) => {
                    data.td_giaonhan_trong_han_key = data?.td_giaonhan_trong_han ?? 0;
                },
            },
            td_giaonhan_tre_han_key: {
                name: 'td_giaonhan_tre_han_key',
                type: "Computed",
                label: 'Tổng VB TĐ giao nhận trễ hạn',
                width: 10,
                class: "center",
                computed: (data) => {
                    data.td_giaonhan_tre_han_key = data?.td_giaonhan_tre_han ?? 0;
                },
            },
            td_nt3_trong_han_key: {
                name: 'td_nt3_trong_han_key',
                type: "Computed",
                label: 'Tổng VB TĐ NT3 trong hạn',
                width: 10,
                class: "center",
                computed: (data) => {
                    data.td_nt3_trong_han_key = data?.td_nt3_trong_han ?? 0;
                },
            },
            td_nt3_tre_han_key: {
                name: 'td_nt3_tre_han_key',
                type: "Computed",
                label: 'Tổng VB TĐ NT3 trễ hạn',
                width: 10,
                class: "center",
                computed: (data) => {
                    data.td_nt3_tre_han_key = data?.td_nt3_tre_han ?? 0;
                },
            },
            td_nt3_ub_trong_han_key: {
                name: 'td_nt3_ub_trong_han_key',
                type: "Computed",
                label: 'Tổng VB TĐ NT3 có XN UB trong hạn',
                width: 10,
                class: "center",
                computed: (data) => {
                    data.td_nt3_ub_trong_han_key = data?.td_nt3_ub_trong_han ?? 0;
                },
            },
            td_nt3_ub_tre_han_key: {
                name: 'td_nt3_ub_tre_han_key',
                type: "Computed",
                label: 'Tổng VB TĐ NT3 có XN UB trễ hạn',
                width: 10,
                class: "center",
                computed: (data) => {
                    data.td_nt3_ub_tre_han_key = data?.td_nt3_ub_tre_han ?? 0;
                },
            },
            td_niemyet_trong_han_key: {
                name: 'td_niemyet_trong_han_key',
                type: "Computed",
                label: 'Tổng VB NY trong hạn',
                width: 10,
                class: "center",
                computed: (data) => {
                    data.td_niemyet_trong_han_key = data?.td_niemyet_trong_han ?? 0;
                },
            },
            td_niemyet_tre_han_key: {
                name: 'td_niemyet_tre_han_key',
                type: "Computed",
                label: 'Tổng VB NY trễ hạn',
                width: 10,
                class: "center",
                computed: (data) => {
                    data.td_niemyet_tre_han_key = data?.td_niemyet_tre_han ?? 0;
                },
            },
            td_khongthanh_trong_han_key: {
                name: 'td_khongthanh_trong_han_key',
                type: "Computed",
                label: 'Tổng VB TĐ Không thành trong hạn',
                width: 10,
                class: "center",
                computed: (data) => {
                    data.td_khongthanh_trong_han_key = data?.td_khongthanh_trong_han ?? 0;
                },
            },
            td_khongthanh_tre_han_key: {
                name: 'td_khongthanh_tre_han_key',
                type: "Computed",
                label: 'Tổng VB Không thành trễ hạn',
                width: 10,
                class: "center",
                computed: (data) => {
                    data.td_khongthanh_tre_han_key = data?.td_khongthanh_tre_han ?? 0;
                },
            },
            td_tralai_toa_key: {
                name: 'td_tralai_toa_key',
                type: "Computed",
                label: 'Tổng VB trả lại tòa (loại 4)',
                width: 10,
                class: "center",
                computed: (data) => {
                    data.td_tralai_toa_key = data?.td_tralai_toa ?? 0;
                },
            },
            total_inventory_in_key: {
                name: 'total_inventory_in_key',
                type: "Computed",
                label: 'Tổng VB Tồn trong hạn',
                width: 10,
                class: "center",
                computed: (data) => {
                    data.total_inventory_in_key = data?.total_inventory_in ?? 0;
                },
            },
            total_inventory_out_key: {
                name: 'total_inventory_out_key',
                type: "Computed",
                label: 'Tổng VB Tồn trễ hạn',
                width: 10,
                class: "center",
                computed: (data) => {
                    data.total_inventory_out_key = data?.total_inventory_out ?? 0;
                },
            },
            
        },)
    }

}